import { createFoSelection } from "./createFoSelection";
import moment from 'moment';

export const parseFoOdds = (foPool, message, content) => {
    let lastUpdateTime = foPool.lastUpdateTime
    message.cmb?.forEach(cmb => {
        lastUpdateTime = new Date(lastUpdateTime) > new Date(cmb.cur.updAt) ? lastUpdateTime : cmb.cur.updAt
        let foSel = foPool.selections?.find(x=> x.combId===cmb.id);
        if( !foSel ) {
            foSel = createFoSelection();
            foSel.combId = cmb.id;
            foSel.number = parseInt(cmb.str);
            foPool.selections.push(foSel);
        }
        foSel.openOdds = cmb.opn.odds?cmb.opn.odds:"";
        foSel.prevOdds = cmb?.prev?.odds || '';
        // if ( cmb.prev ) {
        //     foSel.prevOdds = cmb.prev.odds;
        // }
        foSel.currentOdds = cmb.cur.odds;
        foSel.combStatus = cmb.st.toUpperCase();
        foSel.lineId = message.lineId;
        let cbDisabled = !['SELLING_STARTED', 'SELLINGSTARTED'].includes(foPool.status.toUpperCase()) || foPool.sellStatus!="Available" || foSel.combStatus!="AVAILABLE"
        if(cbDisabled){
            let mtg = content.meeting
            let betType = foPool.oddsType
            let id =  `${betType}#${mtg.id}#${foPool.poolId}#${foSel.combId}`
            content.setFOSelectedBet(foSelectedBet=>{
                delete foSelectedBet[id]
                return foSelectedBet
            })
        }
    });
    foPool.lastUpdateTime = lastUpdateTime
}